module.exports = __webpack_public_path__ + "static/uni_alabama-8eb509c8d0fc8d1acf022eca92c5254e.png";